let loadedPlaces = {};

export default class Place {
    static autoload() {
        if (window.google === undefined) {
            return;
        }

        if (location.search) {
            const data = window.queryString.parse(location.search);

            if (data.place_id !== undefined && typeof data.place_id === 'string') {
                const placeId = data.place_id;

                if (!loadedPlaces.hasOwnProperty(placeId)) {
                    Place.loadPlace(placeId);
                }
            } else if (data.postcode && typeof data.postcode === 'string') {
                Place.loadPlaceUsingAddress(data.postcode);
            }
        }
    }

    static loadPlace(placeId) {
        if (loadedPlaces[placeId] !== undefined) {
            return loadedPlaces[placeId];
        }

        const geocoder = new window.google.maps.Geocoder;

        geocoder.geocode({ placeId }, (results, status) => {
            loadedPlaces[placeId] = null;

            if (status === 'OK' && results[0]) {
                loadedPlaces[placeId] = results[0];

                window.Events.dispatch('google.place.load', results[0]);
            }
        });
    }

    static loadPlaceUsingAddress(address, events) {
        const geocoder = new window.google.maps.Geocoder;

        geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results[0]) {
                loadedPlaces[results[0].place_id] = results[0];

                window.Events.dispatch('google.place.load', results[0]);

                if (events) {
                    window.Events.dispatch(events, results[0]);
                }
            }
        });
    }

    static geocodeCoordinates(coordinates) {
        const location = {
            lat: parseFloat(coordinates.lat),
            lng: parseFloat(coordinates.lng)
        };

        const geocoder = new window.google.maps.Geocoder;

        try {
            geocoder.geocode({location}, (results, status) => {
                if (status === 'OK' && results[0]) {
                    window.Events.dispatch('geolocation.allowed', results[0]);
                } else {
                    window.Events.dispatch('geolocation.failed');
                }
            });
        } catch (error) {
            window.Events.dispatch('geolocation.failed');
        }
    }
}
